import { render, staticRenderFns } from "./routerCustom.vue?vue&type=template&id=1e1fe258"
import script from "./routerCustom.vue?vue&type=script&lang=js"
export * from "./routerCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports